export default "__VITE_ASSET__BF_xUb66__"